<template>
    <div
            class="modal fade"
            id="sys_ammeterpic_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">电表照片</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body">
                    <div class="col-sm-12 uploadFile">
                        <div class="col-sm-2">上传照片</div>
                        <div class="col-sm-4">
                            <input
                                    type="file"
                                    class="form-control file-pretty_ammeterPic"
                                    id="ammeterPic"
                                    @change="changeImg('ammeterPic')"
                            />
                        </div>
                    </div>
                    <div class="col-sm-6 photolist" v-for="(item,index) in piclist" :key="index">
                        <img :src="item.photoPath" alt/>
                        <p>上传时间:{{item.create_time}}</p>
                    </div>
                </div>
                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <button type="button" class="btn btn-primary" @click="submit">提交</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        piclist: [], // 原电表照片
        filePath: '' // 新上传电表照片
      }
    },
    props: ['msgAmmeterid'],
    mounted: function () {
      $('.file-pretty_ammeterPic').prettyFile()
    },
    methods: {
      getData: function () {
        console.log('getData--pic')
        var self = this
        var ammeterId = self.msgAmmeterid
        self.global.axiosGet(
          self,
          'ammeter/' + ammeterId + '/pictures/',
          function (res) {
            //   console.log(res);
            if (res && res.length) {
              res.forEach(item => {
                item.photoPath = self.global.ossHost + item.photo_path
              })
              self.piclist = res
            }
          }
        )
      },
      changeImg: function () {
        // 上传返回file_path;
        var self = this
        self.global.uploadfile(
          self,
          'ammeterPic',
          function (res) {
            console.log(res)
            if (res.status == 'success') {
              // console.log(res.file_path);
              self.filePath = res.file_path
            } else {
              alert('图片上传失败')
            }
          },
          function () {
            alert('图片上传失败')
          }
        )
      },
      submit: function () {
        var self = this
        //ammeter/(ammeter_id)/pictures/
        self.global.axiosPost(
          self,
          'ammeter/' + self.msgAmmeterid + '/pictures/',
          { file_path: self.filePath },
          function (res) {
            if (res.status == 'success') {
              alert('上传成功')
              $('#sys_ammeterpic_modal').modal('hide')
            } else {
              alert('上传失败')
            }
          },
          function () {
            alert('提交失败')
          }
        )
      }
    }
  }
</script>
<style scoped>
    .uploadFile {
        margin-bottom: 10px;
    }

    .photolist img {
        width: 100%;
    }

    .photolist p {
        font-size: 16px;
        text-align: center;
        padding: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/views/ammeter/ammeterpic.vue